<template>
  <div>
    <a-skeleton active :paragraph="{ rows: 6 }" :loading="loadingItem">
      <div>
        <a-form-model
          labelAlign="left"
          :model="form"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          ref="ruleForm"
          :rules="rules"
        >
          <a-form-model-item label="Name / Tên ứng dụng" prop="name">
            <a-input v-model="form.name" placeholder="Enter name" />
          </a-form-model-item>
          <a-form-model-item label="URL / Đường dẫn truy cập" prop="url">
            <a-input v-model="form.url" placeholder="Enter URL" />
          </a-form-model-item>
          <a-form-model-item label="Icon" prop="iconUrl">
            <a-input
              v-model="form.iconUrl"
              placeholder="Enter address url of icon"
            />
            <br />
            <div style="max-width: 64px; margin-top: 20px;" v-if="form.iconUrl">
              <img alt="previewIcon" style="width: 100%;" :src="form.iconUrl" />
            </div>
          </a-form-model-item>
          <a-form-model-item label="App Group" prop="groupId">
            <SelectAppInPlatformGroup
              v-model="form.groupId"
              :initial-datas="form.vehicleType ? [form.vehicleType] : null"
              :select-props="{
                value: form.groupId || undefined,
                placeholder: 'Choose location',
              }"
            />
          </a-form-model-item>
          <a-form-model-item>
            <a-checkbox v-model="form.openNewTab"> Open new tab </a-checkbox>
          </a-form-model-item>
          <a-row :gutter="12">
            <a-col :span="12">
              <a-form-model-item>
                <a-checkbox v-model="form.isV1">V1</a-checkbox>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item>
                <a-checkbox v-model="form.isV2">V2</a-checkbox>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-form-model-item label="Number Order">
            <a-input-number
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
              :min="0"
              v-model="form.numberOrder"
              placeholder="Enter number..."
              style="width: 100%;"
            />
          </a-form-model-item>
          <a-form-model-item label="Description / Mô tả">
            <a-textarea
              v-model="form.description"
              placeholder="Enter description"
              :auto-size="{ minRows: 5 }"
            />
          </a-form-model-item>
        </a-form-model>
        <a-divider />
        <a-checkbox v-model="form.isPublishedToAllUser">
          All user have permission access / Tất cả tài khoản đều truy cập được
        </a-checkbox>
        <div class="label-fullwidth" style="width: 100%; margin-top: 20px;">
          <div slot="label">
            Permission access / Tài khoản cho phép truy cập ({{
              appInPlatform.isPublishedToAllUser
                ? "All"
                : appInPlatform.userCanAccess
                ? appInPlatform.userCanAccess.length
                : 0
            }})
            <a-button
              v-if="!appInPlatform.isPublishedToAllUser"
              @click="visibleManage = true"
              type="link"
              style="float: right;"
              title="Manage permission"
            >
              <a-icon type="setting" />
            </a-button>
            <a-button
              v-if="!appInPlatform.isPublishedToAllUser"
              @click="visibleAdd = true"
              type="link"
              style="float: right;"
              title="Add permission"
            >
              <a-icon type="plus" />
            </a-button>
            <br />
          </div>
        </div>
        <div
          v-if="form.isPublishedToAllUser"
          class="label-fullwidth"
          style="width: 100%; margin-top: 20px;"
        >
          <div slot="label">
            Permission except / Tài khoản từ chối truy cập ({{
              (appInPlatform.excludeUsers &&
                appInPlatform.excludeUsers.length) ||
              0
            }})
            <a-button
              @click="visibleManageExcept = true"
              type="link"
              style="float: right;"
              title="Manage permission"
            >
              <a-icon type="setting" />
            </a-button>
            <a-button
              @click="visibleAddExcept = true"
              type="link"
              style="float: right;"
              title="Add permission"
            >
              <a-icon type="plus" />
            </a-button>
            <br />
          </div>
        </div>
      </div>
    </a-skeleton>
    <div
      :style="{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: '100%',
        borderTop: '1px solid #e9e9e9',
        padding: '10px 16px',
        background: '#fff',
        textAlign: 'right',
        zIndex: 1,
      }"
      style="text-align: right;"
    >
      <a-popconfirm
        title="Confirm action?"
        ok-text="Xóa"
        cancel-text="Không"
        @confirm="onDelete"
      >
        <a-button
          icon="delete"
          type="danger"
          style="float: left;"
          :loading="loadingBtn"
        >
          Delete
        </a-button>
      </a-popconfirm>

      <a-button style="margin-right: 10px;" @click="close">
        Close
      </a-button>
      <a-button type="primary" @click="onSubmit" :loading="loadingBtn">
        Update
      </a-button>
    </div>

    <a-drawer
      title="Permission access"
      placement="right"
      :visible="visibleManage"
      @close="() => (visibleManage = false)"
      :width="350"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <ManageAccessUser
        v-if="visibleManage"
        :close="() => (visibleManage = false)"
        :userCanAccess="this.appInPlatform.userCanAccess || []"
        :idAppConfig="idAppConfig"
        :refreshUserAccessAfterUpdated="refreshUserAccessAfterAdd"
      />
    </a-drawer>

    <a-drawer
      title="Add permission access"
      placement="right"
      :visible="visibleAdd"
      @close="() => (visibleAdd = false)"
      :width="350"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddAccessUser
        v-if="visibleAdd"
        :idAppConfig="idAppConfig"
        :close="() => (visibleAdd = false)"
        :refreshUserAccessAfterAdd="refreshUserAccessAfterAdd"
      />
    </a-drawer>

    <!-- EXCEPT USER PERMISSION -->
    <a-drawer
      title="Add permission except"
      placement="right"
      :visible="visibleAddExcept"
      @close="() => (visibleAdd = false)"
      :width="350"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <AddExceptUser
        :idAppConfig="idAppConfig"
        :close="() => (visibleAddExcept = false)"
        :refreshAfterAdd="refreshUserExceptAfterAdd"
      />
    </a-drawer>

    <a-drawer
      title="Permission except"
      placement="right"
      :visible="visibleManageExcept"
      @close="() => (visibleManageExcept = false)"
      :width="350"
      :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
    >
      <ManageExceptUser
        v-if="visibleManageExcept"
        :close="() => (visibleManageExcept = false)"
        :excludeUsers="this.appInPlatform.excludeUsers || []"
        :idAppConfig="idAppConfig"
        :refreshAfterUpdated="refreshUserExceptAfterAdd"
      />
    </a-drawer>
  </div>
</template>
<script>
import query from "../../constants/query";
import AddAccessUser from "./components/editListApp/addAccessUser";
import ManageAccessUser from "./components/editListApp/manageAccessUser";

const rules = {
  name: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "blur",
    },
  ],
  url: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "blur",
    },
  ],
  iconUrl: [
    {
      required: true,
      message: "Required / Thông tin không được bỏ trống",
      trigger: "blur",
    },
  ],
};

export default {
  components: {
    AddAccessUser,
    ManageAccessUser,
    AddExceptUser: () => import("./components/editListApp/addExceptUser.vue"),
    ManageExceptUser: () =>
      import("./components/editListApp/manageExceptUser.vue"),
    SelectAppInPlatformGroup: () =>
      import("@/components/common/appInPlatformGroup/select"),
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
    refreshAfterUpdated: {
      type: Function,
      required: true,
    },
    refreshAfterDeleted: {
      type: Function,
      required: true,
    },
    idAppConfig: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rules,
      form: {},
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      loadingBtn: false,
      loadingItem: false,
      visibleManage: false,
      visibleManageExcept: false,
      visibleAdd: false,
      visibleAddExcept: false,
      appInPlatform: {},
      keyUpdate: 0,
    };
  },
  methods: {
    onUpdateAppInPlatform() {
      this.loadingBtn = true;
      if (!this.form.id) {
        throw new Error("cannot get id");
      }
      this.$apollo
        .mutate({
          mutation: query.updateAppInPlatform,
          variables: {
            url: this.form.url,
            iconUrl: this.form.iconUrl,
            name: this.form.name,
            description: this.form.description,
            openNewTab: this.form.openNewTab,
            userCanAccessIds: this.form.userCanAccessIds,
            id: this.form.id,
            isPublishedToAllUser: this.form.isPublishedToAllUser,
            groupId: this.form.groupId,
            isV1: this.form.isV1,
            isV2: this.form.isV2,
            numberOrder: this.form.numberOrder,
          },
        })
        .then(({ data }) => {
          if (data?.updateAppInPlatform) {
            this.refreshAfterUpdated(data.updateAppInPlatform);
            this.appInPlatform = {
              ...this.appInPlatform,
              ...data.updateAppInPlatform,
            };
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Updated Success!",
          });
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Updated Error!", error);
        });
    },
    onGetAppInPlatform(id) {
      this.loadingItem = true;
      this.$apollo
        .query({
          query: query.getAppInPlatform,
          variables: { id },
        })
        .then(({ data }) => {
          if (data?.getAppInPlatform) {
            this.appInPlatform = { ...data.getAppInPlatform };
            this.form = { ...data.getAppInPlatform };
          }
          this.loadingItem = false;
        })
        .catch((error) => {
          this.loadingItem = false;
          console.log("Không lấy được chi tiết", error);
        });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.onUpdateAppInPlatform();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    onDelete() {
      if (!this.form.id) {
        throw new Error("cannot get id");
      }
      this.$apollo
        .mutate({
          mutation: query.deleteAppInPlatform,
          variables: {
            id: this.form.id,
          },
        })
        .then(({ data }) => {
          if (data?.deleteAppInPlatform) {
            this.refreshAfterDeleted(data.deleteAppInPlatform);
          }
          this.loadingBtn = false;
          this.$notification.success({
            message: "Success",
            description: "Deleted Success!",
          });
          this.close();
        })
        .catch((error) => {
          this.loadingBtn = false;
          this.$notification.error({
            message: "Error",
            description: "Deleted Error!",
          });
          console.log("Deleted Error!", error);
        });
    },
    refreshUserAccessAfterAdd(users) {
      if (this.appInPlatform) {
        this.appInPlatform.userCanAccess = [...users];
      }
    },
    refreshUserExceptAfterAdd(users) {
      if (this.appInPlatform) {
        this.appInPlatform.excludeUsers = [...users];
      }
    },
  },
  created() {
    if (this.idAppConfig) {
      this.onGetAppInPlatform(this.idAppConfig);
    }
  },
};
</script>
<style lang="css" scoped>
.label-fullwidth >>> label {
  width: 100% !important;
}
</style>
